
import { useState } from 'react';
import Header from '../../components/feature/Header';
import LoginForm from './components/LoginForm';
import Dashboard from './components/Dashboard';

interface User {
  name: string;
  role: string;
  email: string;
}

export default function Home() {
  const [user, setUser] = useState<User | null>(null);

  const handleLogin = (credentials: { email: string; password: string }) => {
    // Simulate authentication with different user roles
    const users: Record<string, User> = {
      'investor@example.com': {
        name: 'Michael Rodriguez',
        role: 'Investor',
        email: 'investor@example.com'
      },
      'partner@example.com': {
        name: 'Sarah Chen',
        role: 'Senior Partner',
        email: 'partner@example.com'
      },
      'admin@example.com': {
        name: 'David Al-Mansouri',
        role: 'Administrator',
        email: 'admin@example.com'
      }
    };

    const authenticatedUser = users[credentials.email] || users['investor@example.com'];
    setUser(authenticatedUser);
  };

  const handleLogout = () => {
    setUser(null);
  };

  if (!user) {
    return <LoginForm onLogin={handleLogin} />;
  }

  return (
    <div className="min-h-screen bg-neutral-950 text-zinc-100">
      <Header user={user} onLogout={handleLogout} />
      <Dashboard user={user} />
    </div>
  );
}
